import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    giftCollections: [],
    selectedFilters: [],
    selectedCollection: null,
    addressQty: 1,
    addresses: [],
    emailFile: null,
    emailFileData: null,
    multipleNotificationDate: true,
  },
  getters,
  mutations,
  actions,
});

export default store;
